var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import { State, Getter } from "vuex-class";
import { UserService } from "~/services/manage-service/user.service";
import { CaseFollowRecordService } from "~/services/business-service/case-follow-record.service";
import { SortService } from "~/utils/sort.service";
import { PageService } from "~/utils/page.service";
import PrincipalBatch from "~/components/common-business/principal-batch.vue";
import assetsRequest from "~/utils/assets.request";
var DayCollectionStatistic = /** @class */ (function (_super) {
    __extends(DayCollectionStatistic, _super);
    function DayCollectionStatistic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false,
        };
        _this.searchModel = {
            certificateNo: "",
        };
        _this.dataSet = [];
        _this.page = 1;
        _this.size = 10;
        _this.total = 0;
        return _this;
    }
    DayCollectionStatistic.prototype.handleSizeChange = function (val) {
        this.size = val;
        this.refreshData();
    };
    DayCollectionStatistic.prototype.handleResetForm = function () {
        this.searchModel.certificateNo = "";
    };
    DayCollectionStatistic.prototype.handleCurrentChange = function (val) {
        this.page = val;
        this.refreshData();
    };
    DayCollectionStatistic.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * 刷新列表
     */
    DayCollectionStatistic.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        assetsRequest.get("/tjCaseQueryLog/list", {
            pageNo: this.page,
            pageSize: this.size,
            certificateNo: this.searchModel.certificateNo,
        }).then(function (data) {
            _this.loading.state = false;
            if (data['code'] === 0) {
                _this.dataSet = data.data.records;
                _this.total = data.data.total;
            }
            else {
                _this.$message.error(data['message']);
            }
        }).catch(function (error) {
            console.log(error);
            _this.loading.state = false;
        });
    };
    __decorate([
        Dependencies(UserService)
    ], DayCollectionStatistic.prototype, "userService", void 0);
    __decorate([
        Dependencies(SortService)
    ], DayCollectionStatistic.prototype, "sortService", void 0);
    __decorate([
        Dependencies(PageService)
    ], DayCollectionStatistic.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseFollowRecordService)
    ], DayCollectionStatistic.prototype, "caseFollowRecordService", void 0);
    __decorate([
        Getter
    ], DayCollectionStatistic.prototype, "departmentData", void 0);
    __decorate([
        State
    ], DayCollectionStatistic.prototype, "userToken", void 0);
    DayCollectionStatistic = __decorate([
        Layout("workspace"),
        Component({
            components: {
                PrincipalBatch: PrincipalBatch,
                DataForm: DataForm,
                DataBox: DataBox,
            },
        })
    ], DayCollectionStatistic);
    return DayCollectionStatistic;
}(Vue));
export default DayCollectionStatistic;
